// Single Plan
export const CREATE_PLAN = "CREATE_PLAN";
export const FETCH_PLAN = "FETCH_PLAN";
export const UPDATE_PLAN = "UPDATE_PLAN";
export const RESET_PLAN = "RESET_PLAN";

// Plan list
export const ADD_PLAN_TO_LIST = "ADD_PLAN_TO_LIST";
export const UPDATE_PLAN_IN_LIST = "UPDATE_PLAN_IN_LIST";
export const DELETE_PLAN_FROM_LIST = "DELETE_PLAN_FROM_LIST";

// Places List
export const GET_PLACE_LIST = "SET_PLACE_LIST";
export const RESET_PLACE_LIST = "RESET_PLACE_LIST";
export const ADD_PLACE_TO_LIST = "ADD_PLACE_TO_LIST";
export const DELETE_PLACE_FROM_LIST = "DELETE_PLACE_FROM_LIST";

// Users
export const USER_SIGN_IN_REQUEST = "USER_SIGN_IN_REQUEST";
export const USER_SIGN_IN_SUCCESS = "USER_SIGN_IN_SUCCESS";
export const USER_SIGN_IN_FAIL = "USER_SIGN_IN_FAIL";
export const USER_SIGN_OUT_SUCCESS = "USER_SIGN_OUT_SUCCESS";

// Alerts
export const SHOW_SUCCESS_ALERT = "SHOW_SUCCESS_ALERT";
export const SHOW_ERROR_ALERT = "SHOW_ERROR_ALERT";
export const CLEAR_ALERT = "CLEAR_ALERT";
